import React from 'react';
import HighlightedEventsSection from './homepage/HighlightedEventsSection';

const HomepageContent = () => <>
    <HighlightedEventsSection />
    {/* Re-insert <TestimonialsSection /> here once we have some testimonials */}
</>;

export default HomepageContent;
